import BaseComponent from "../../../baseComponent";
import styles from "./styles.scss";

export default class SeparatorWidget extends BaseComponent {

  constructor(prop) {
    super(prop);
  }

  componentDidMount() {
    $($(this.refs.container).parents("li")[0]).css("border-bottom", "none");
  }

  render() {
    return (
      <div className={styles.container} ref="container">
        <div />
        <div />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/separator/separatorWidget.jsx